export const blockIconsEditorDraw = (
	<span className='material-symbols-outlined'>draw</span>
);
